import { RECIPE_ENDPOINTS } from "./endpoints";
import type { Recipe } from "./types";
import { apiGet } from "../shared";
import { extractRecipes } from "./helpers";

function buildRecipesUrl(dietTypes: string[]): string {
  if (dietTypes.length === 0) return RECIPE_ENDPOINTS.GET_ALL;
  const encodedDiets = encodeURIComponent(dietTypes.join(","));
  return `${RECIPE_ENDPOINTS.GET_ALL}?diets=${encodedDiets}`;
}

export default async function getRecipes(dietTypes: string[] = []): Promise<Recipe[]> {
  const url = buildRecipesUrl(dietTypes);
  const response = await apiGet<{ data?: Recipe[] } | Recipe[]>(url);
  return extractRecipes(response);
}
